import { render, staticRenderFns } from "./CookieIndex.vue?vue&type=template&id=09b2fb08&scoped=true"
import script from "./CookieIndex.vue?vue&type=script&lang=js"
export * from "./CookieIndex.vue?vue&type=script&lang=js"
import style0 from "./CookieIndex.vue?vue&type=style&index=0&id=09b2fb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2fb08",
  null
  
)

export default component.exports